<script setup lang="ts">
  defineProps<{
    suffix: string
    single?: boolean
  }>();
</script>

<template>
  <div
    class="bg-white border border-gray-500 rounded-xl h-[48px] px-5 flex items-center justify-center text-gray-500"
  >
    <v-slider
      v-if="single"
      v-bind="$attrs"
      color="var(--color-base-500)"
      hide-details="auto"
      track-color="var(--color-base-200)"
    />
    <v-range-slider
      v-else
      v-bind="$attrs"
      color="var(--color-base-500)"
      hide-details="auto"
      track-color="var(--color-base-200)"
    />
    <span>
      {{ suffix }}
    </span>
  </div>
</template>
